<template>
  <v-row justify="center">
    <v-dialog v-model="inputDialog"
        :persistent="true"
        width="50%"
        height="100%"
        class="modalDialog"
        no-click-animation
    >
      <v-card class="cardWrap">
        <CardTitle :title="page_title" />
          <v-container>
            <v-col cols="12" md="12">
              <v-row>
                <v-form
                    ref="form"
                    lazy-validation
                  >
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title">氏名</div>
                    <v-text-field :value="name" disabled/>
                  </v-row>
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title">ゴルフ場</div>
                    <v-select
                        :items="golf_courses"
                        item-value="golf_code"
                        item-text="golf_name"
                        :disabled="changeModeStatus"
                        v-model="from_set_data.golf_courses_val"
                        :rules="[rules.required_golf_course]"
                        autofocus
                    />
                  </v-row>
                  <v-row justify="start">
                    <div class="cardWrap__fromArea__title">カード番号</div>
                    <v-text-field
                        v-model="from_set_data.card_no"
                        :rules="[rules.required_card_no, rules.format_card_no, rules.max_length_card_no]"
                    />
                  </v-row>
                </v-form>
              </v-row>
            </v-col>
          </v-container>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-4" text @click="CloseModal">キャンセル</v-btn>
            <v-btn color="blue  darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
            <v-btn color="green darken-4" text v-if="changeModeStatus" @click="validateCheck">変更</v-btn>
         </v-card-actions>
        <AddOverlay
            page-name="カード番号"
            @processing="addMemberCardNo"
            @cancel="addOverlay = !addOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="addOverlay"
            />
        <ChangeOverlay
            page-name="カード番号"
            @processing="updateMemberCardNo"
            @cancel="changeOverlay = !changeOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="changeOverlay"
            />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import {
    REGISTER_MEMBER_CARD_NO,
    UPDATE_MEMBER_CARD_NO
} from '@/constants/member_card';
import AddOverlay from '@/views/Master/page/overlay/AddOverlay';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import { InputPageMixin } from '@/views/Member/InputPageMixin.js';
import validater from '@/lib/validater';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    mixins: [InputPageMixin],
    props: [
        'editInfo',
        'name',
        'MemNo',
        'golf_courses',
        'golf_code'
    ],
    data () {
        return {
            page_title: 'カードNo登録',
            // 入力値
            from_set_data: {
                id: '',
                golf_courses_val: '',
                card_no: ''
            },
            // MemberCardNoListのヘッダー
            headers: [
                { text: 'ゴルフ場', align: 'center', value: 'golf_name', sortable: false },
                { text: 'カード番号', align: 'center', value: 'card_no', sortable: false },
                { text: '', align: 'center', value: 'Btn', sortable: false }
            ],
            // バリデーションルール
            rules: {
                // カード番号バリデーション
                required_card_no: value => !!value || this.$t('error.validation.required.cardNo'),
                format_card_no: value => !!validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                max_length_card_no: value => value.length <= 60 || this.$t('error.validation.length.cardNo'),
                // ゴルフ場バリデーション
                required_golf_course: value => !!value || this.$t('error.validation.required.GolfCourse')
            },
            adminData: []
        };
    },
    watch: {
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.$set(this.from_set_data, 'golf_courses_val', this.golf_code);
                this.page_title = 'カードNo登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = 'カードNo変更';
            }
        },
        editInfo () {
            this.from_set_data.id = this.editInfo.id;
            this.from_set_data.golf_courses_val = this.editInfo.golf_code;
            this.from_set_data.card_no = this.editInfo.card_no;
        }
    },
    methods: {
        addMemberCardNo () {
            // 二重送信防止処理
            if (this.processing) return;
            this.processing = true;

            this.$apollo.mutate({
                mutation: REGISTER_MEMBER_CARD_NO,
                variables: {
                    member_no: this.MemNo,
                    golf_group_code: this.golf_groups_val,
                    golf_code: this.from_set_data.golf_courses_val,
                    card_no: this.from_set_data.card_no
                }
            }).then(res => {
                this.process.result = res.data.registerCardNo.result;
                // 結果が正常であれば、okを表示
                if (this.process.result === 1) {
                    this.addOverlay = !this.addOverlay;
                    this.CloseModal();
                } else if (this.process.result === 0) {
                    this.process.resultText = res.data.registerCardNo.errorMessage;
                }
                this.processing = false;
            }).catch(error => {
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.regist');
                this.error = error;
                this.processing = false;
            });
        },
        updateMemberCardNo () {
            // 二重送信防止処理
            if (this.processing) return;
            this.processing = true;

            this.modeStatus = 'changeMode';
            this.$apollo.mutate({
                mutation: UPDATE_MEMBER_CARD_NO,
                variables: {
                    id: this.from_set_data.id,
                    golf_code: this.from_set_data.golf_courses_val,
                    card_no: this.from_set_data.card_no }
            }).then(res => {
                this.process.result = res.data.updateCardNo.result;
                if (this.process.result === 1) {
                    this.changeOverlay = !this.changeOverlay;
                    this.CloseModal();
                } else if (this.process.result === 0) {
                    this.process.resultText = res.data.updateCardNo.errorMessage;
                }
                this.processing = false;
            }).catch(error => {
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.change');
                this.error = error;
                this.processing = false;
            });
        }
    }
};
</script>

<style scoped>
.cardWrap{
    margin: 0;
    padding: 20px 15px 15px;
    height: 400px;
}

.v-card{
    box-shadow: none;
}

.v-text-field {
    width: 300px;
}

.formWidth{
  max-width: 60%;
}

.modalDialog ::v-deep .px-3{
  padding-right: 0px !important;
  padding-left: 0px !important;
}

</style>
